(() => {
  'use strict';
  const configNode = document.getElementById('hi-preorder-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const ids = new Set(config.variants.map(String));
  if (!ids.size) return;
  function install() {
    const $ = window.jQuery;
    if (!$ || window.hiPreorderCartReady) return;
    window.hiPreorderCartReady = true;
    // Preserve the notice in theme AJAX paths such as wishlist and quick shop.
    $.ajaxPrefilter(options => {
      if (!/\/cart\/add(?:\.js)?$/.test(new URL(options.url, location.origin).pathname) || String(options.type).toUpperCase() !== 'POST') return;
      if (typeof options.data !== 'string') return;
      if (String(options.contentType).includes('application/json')) {
        try {
          const data = JSON.parse(options.data);
          (data.items || [data]).forEach(item => {
            if (ids.has(String(item.id))) item.properties = { ...item.properties, 'Pre-order': config.message };
          });
          options.data = JSON.stringify(data);
        } catch (_) { /* Leave unrelated or malformed payloads to Shopify. */ }
      } else {
        const data = new URLSearchParams(options.data);
        if (ids.has(data.get('id'))) data.set('properties[Pre-order]', config.message);
        [...data.keys()].forEach(key => {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (match && ids.has(data.get(key))) data.set(`items[${match[1]}][properties][Pre-order]`, config.message);
        });
        options.data = data.toString();
      }
    });
  }
  if (window.themeReady) window.themeReady(install); else install();
})();
